<template>
  <section class="library-section">
    <div class="container">
      <h1 class="title">{{ libraryPageTitle }}</h1>

      <div class="events-container">
        <EventCard
          v-for="(event, index) in libraryEvents"
          :key="index"
          :event="event"
          :past-event="hasUpcomingEvents && date === undefined"
        />
      </div>

      <button
        v-if="hasMore && !loading"
        class="load-more"
        @click="getEvents"
      >
        <span>Explore more events</span>
        <ChevronDownIcon />
      </button>
    </div>
  </section>
</template>

<script>
import EventCard from '../EventCard/EventCard.vue';
import ChevronDownIcon from '~/components/Common/Svg/ChevronDownIcon.vue';
import { useEventsStore } from '~/stores/events';
export default {
  components: {
    EventCard,
    ChevronDownIcon,
  },
  props: {
    libraryEvents: {
      type: Array,
      default: () => [],
    },
    hasUpcomingEvents: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      eventsStore: useEventsStore(),
    };
  },
  computed: {
    hasMore() {
      return this.eventsStore.hasMoreEvents;
    },
    libraryPageTitle() {
      return !this.hasUpcomingEvents && this.date !== undefined
        ? `Events in ${this.date}`
        : 'Watch past events';
    },
    date() {
      return this.$route.query.date;
    },
  },
  methods: {
    async getEvents() {
      this.loading = true;
      this.eventsStore.incrementCurrentPage();

      try {
        const libraryEvents = await this.$cmsApi.get('/events/library', {
          ...this.eventsStore.filterParams,
          ...this.eventsStore.paginationParams,
        });
        this.eventsStore.setLibraryEvents(libraryEvents);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './LibrarySection.scss';
</style>
